import { useAppSelector } from '@frontend/common';
import { PackageTypeConstraintData, isPackageTypeConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PackageTypeConstraintDataInputProps } from './package-type-constraint-data-input.component';

interface ViewProps {
    formValues: PackageTypeConstraintData;
}

const usePackageTypeConstraintDataInput = (props: PackageTypeConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isPackageTypeConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { package_type: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default usePackageTypeConstraintDataInput;
